'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const NotificationIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.6 17.6C14.6 19 13.4 20.2 12 20.2C10.6 20.2 9.40002 19 9.40002 17.6M18.7 15.9C19.1 15.9 19.3 15.5 19.1 15.1C18.6 14.4 18 13.4 17.9 12.9C17.7 12.1 17.9 9.79999 17.9 9.79999C17.9 6.79999 15.6 3.99999 12.5 3.69999C9.00002 3.49999 6.00002 6.09999 6.00002 9.49999C6.00002 9.49999 6.20002 12.1 6.00002 12.9C5.90002 13.4 5.30002 14.4 4.80002 15.1C4.60002 15.4 4.80002 15.9 5.20002 15.9H18.7Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpNotificationIcon = forwardRef(NotificationIcon);

export { VpNotificationIcon as default };
